import React, { useState, useEffect } from 'react';
import { Users, FileText, CreditCard, GitBranch, ClipboardCheck, BarChart3, Target, RotateCcw, ArrowRightLeft } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import SalesPipeline from './SalesPipeline';
import QuotationBuilder from './QuotationBuilder';
import CustomerManager from './CustomerManager';
import OrderConfirmationModule from './OrderConfirmationModule';
import SalesAnalytics from './SalesAnalytics';
import ProformaInvoiceModule from './ProformaInvoiceModule';
import SalesTargets from './SalesTargets';
import SalesReturnModule from './SalesReturnModule';
import StockTransferModule from './StockTransferModule';

const tabs = [
  { id: 'analytics', label: 'Analytics', icon: BarChart3 },
  { id: 'pipeline', label: 'Pipeline', icon: GitBranch },
  { id: 'customers', label: 'Customers', icon: Users },
  { id: 'quotations', label: 'Quotations', icon: FileText },
  { id: 'order-confirmations', label: 'Order Confirmations', icon: ClipboardCheck },
  { id: 'stock-transfer', label: 'Stock Transfer', icon: ArrowRightLeft },
  { id: 'proforma-invoice', label: 'Proforma Invoice', icon: CreditCard },
  { id: 'sales-returns', label: 'Sales Returns', icon: RotateCcw },
  { id: 'targets', label: 'Targets', icon: Target },
];

const SalesModule = () => {
  const [activeTab, setActiveTab] = useState('analytics');
  const location = useLocation();

  // Handle deep-link: ?tab=order-confirmations&oc={id}
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get('tab');
    if (tab && tabs.some(t => t.id === tab)) {
      setActiveTab(tab);
    }
  }, [location.search]);

  return (
    <div className="p-5 lg:p-6">
      <div className="mb-5">
        <h1 className="text-xl font-bold text-gray-900" style={{ fontFamily: 'DM Sans' }}>Sales Management</h1>
        <p className="text-xs text-gray-500 mt-0.5">Pipeline, quotations, order confirmations & customer management</p>
      </div>

      {/* Tabs */}
      <div className="flex gap-1 mb-5 bg-gray-100 p-1 rounded-xl w-fit overflow-x-auto">
        {tabs.map(t => (
          <button key={t.id} onClick={() => setActiveTab(t.id)}
            data-testid={`sales-tab-${t.id}`}
            className={`flex items-center gap-1.5 px-4 py-2 text-[11px] font-semibold rounded-lg transition-all whitespace-nowrap ${
              activeTab === t.id ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'
            }`}>
            <t.icon className="w-3.5 h-3.5" />{t.label}
          </button>
        ))}
      </div>

      {activeTab === 'analytics' && <SalesAnalytics />}
      {activeTab === 'pipeline' && <SalesPipeline />}
      {activeTab === 'customers' && <CustomerManager />}
      {activeTab === 'quotations' && <QuotationBuilder />}
      {activeTab === 'order-confirmations' && <OrderConfirmationModule />}
      {activeTab === 'stock-transfer' && <StockTransferModule />}
      {activeTab === 'proforma-invoice' && <ProformaInvoiceModule />}
      {activeTab === 'sales-returns' && <SalesReturnModule />}
      {activeTab === 'targets' && <SalesTargets />}
    </div>
  );
};

export default SalesModule;
